import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FD03 {
  fd03_01: string;        // 類別代號 (PK)
  fd03_02: string;        // 加工類別
  fd03_11: string;        // 類別名稱
  fd03_12: number;        // 隱藏選項標記
  fd03_91: string;        // 建立者代號
  fd03_92: string | null; // 建立日期
  fd03_93: string;        // 更新者代號
}

export interface CreateRequest {
  fd03_01: string;
  fd03_02: string;
  fd03_11: string;
  fd03_12: number;
}

export interface UpdateRequest {
  fd03_02: string;
  fd03_11: string;
  fd03_12: number;
}

export interface ListResponse {
  data: FD03[];
  total: number;
  page: number;
  size: number;
}

// ============================================================
// API methods
// ============================================================

export const d103Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/d103', { params });
    return res.data;
  },

  async get(code: string): Promise<FD03> {
    const res = await apiClient.get(`/api/d103/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FD03> {
    const res = await apiClient.post('/api/d103', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FD03> {
    const res = await apiClient.put(`/api/d103/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/d103/${encodeURIComponent(code)}`);
  },

  async copy(sourceCode: string, data: CreateRequest): Promise<FD03> {
    const res = await apiClient.post(`/api/d103/${encodeURIComponent(sourceCode)}/copy`, data);
    return res.data;
  },
};
